import momentTz from 'moment-timezone'

/**
 * Get formatted timezone label with current UTC offset accounting for DST
 * @param userTimezone - Timezone identifier (e.g., 'Australia/Melbourne')
 * @returns Formatted string like "(UTC+11:00) Australia/Melbourne"
 */
export const getTimezoneLabel = (userTimezone: string): string => {
  if (!userTimezone) return ''
  const tzMoment = momentTz.tz(userTimezone)
  const offset = tzMoment.format('Z')
  return `(UTC${offset})`
}
